import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { CustomerDTO, OrderDTO, OrderItem} from '../models/model';

import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DepFlags } from '@angular/compiler/src/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class OrderService {

  OrderItem:OrderItem;
  Order:OrderDTO
  OrderItems: OrderItem[] = [];
  notifcationService: any;

  constructor(private router: Router,private http: HttpClient,
    private toastrService: ToastrService) { }



    getOrders(param:string){
        return this.http.get<any>(environment.apiUrl + "/Order/"+ param)
        .pipe(
         catchError(this.handleError)
        );
    }

    getOrderStatus(){
      return this.http.get<any>(environment.apiUrl + "/Order")
      .pipe(
       catchError(this.handleError)
      );
    }

    getOrdersItem(param:number){
      return this.http.get<any>(environment.apiUrl + "/OrderItem/"+ param)
      .pipe(
       catchError(this.handleError)
      );

    
  }

  updateOrder(orderid: number, statusid: number) {

    return this.http.post(environment.apiUrl + "/Order/" + orderid + "/" + statusid,null).subscribe(
      data => {
        this.notifcationService.showSuccess("Order", "Order Updated");
      },
      (error) => {
        this.notifcationService.showError("Order", "Order not updated");
        console.error(error);
      }
    );

  }

  


    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };

  
}
